import React, { useEffect } from 'react';
import Invoice from './Invoice';
import { Modal, ModalBody, ModalCloseButton } from '@televet/kibble-ui/build/components/Modal';
import NonItemizedReceipt from 'shared/components/NonItemizedReceipt';

interface IReceiptModalProps {
  isOpen: boolean;
  onClose: () => void;
  invoiceId: string;
  intentId?: string;
  stripeReceiptId?: string;
  paymentIdentifier?: string;
  totalPaid: number;
  clientServiceFee?: number;
  paymentDate?: Date;
  stripePaymentMethod: string[] | null;
  defaultServiceFeePercentage: number;
  clinicPetParentId: string;
}

const ReceiptModal = ({
  isOpen,
  onClose,
  invoiceId,
  intentId,
  stripeReceiptId,
  paymentIdentifier,
  totalPaid,
  clientServiceFee,
  paymentDate,
  stripePaymentMethod,
  defaultServiceFeePercentage,
  clinicPetParentId,
}: IReceiptModalProps): JSX.Element => {
  useEffect(() => {
    if (!isOpen) {
      const printWindows = document.querySelectorAll('#printWindow');
      if (printWindows.length) {
        for (let i = 0; i < printWindows.length; i++) {
          document.body.removeChild(printWindows[i]);
        }
      }
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
      <ModalCloseButton />
      <ModalBody p={0} maxH="90vh">
        {invoiceId ? (
          <Invoice
            defaultServiceFeePercentage={defaultServiceFeePercentage * 100}
            invoiceId={invoiceId}
            totalPaid={totalPaid}
            stripePaymentMethod={stripePaymentMethod}
            isReceipt={true}
            clinicPetParentId={clinicPetParentId}
          />
        ) : (
          <NonItemizedReceipt
            clinicPetParentId={clinicPetParentId}
            intentId={intentId || ''}
            stripeReceiptId={stripeReceiptId}
            paymentIdentifier={paymentIdentifier}
            paymentAmount={totalPaid}
            paymentDate={paymentDate}
            paymentMethod={stripePaymentMethod || []}
            clientServiceFee={clientServiceFee ?? 0}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default ReceiptModal;
